import { render, staticRenderFns } from "./AddLocation.vue?vue&type=template&id=787a4fa9&scoped=true"
import script from "./AddLocation.vue?vue&type=script&lang=js"
export * from "./AddLocation.vue?vue&type=script&lang=js"
import style0 from "./AddLocation.vue?vue&type=style&index=0&id=787a4fa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787a4fa9",
  null
  
)

export default component.exports